// extracted by mini-css-extract-plugin
export default {"container":"review_container__gwy7j","pageName":"review_pageName__fMbn4","top":"review_top__Sc1-z","title":"review_title__si-gt","hint":"review_hint__2+PFB"};